import { Route, Routes } from "react-router-dom";

import { RequireAdmin } from "./auth/RequireAdmin";
import { RequireAuth } from "./auth/RequireAuth";
import { AppLayout } from "./components/AppLayout";

import { AdminsPage } from "./pages/AdminsPage";
import { AdminRedisPage } from "./pages/AdminRedisPage";
import { HomeRoute } from "./pages/HomeRoute";
import { LoginPage } from "./pages/LoginPage";
import { PlaceholderPage } from "./pages/PlaceholderPage";
import { RegisterPage } from "./pages/RegisterPage";
import { LeaderboardsPage } from "./pages/LeaderboardsPage";
import { UsersListPage } from "./pages/UsersListPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { UsersComparePage } from "./pages/UsersComparePage";
import { FlightsListPage } from "./pages/FlightsListPage";
import { UploadPage } from "./pages/UploadPage";
import { UploadResultPage } from "./pages/UploadResultPage";
import { PerformanceRoute } from "./pages/PerformanceRoute";
import { AiCoachPage } from "./pages/ai/AiCoachPage";
import { AiPlannerPage } from "./pages/ai/AiPlannerPage";
import { AiScenariosPage } from "./pages/ai/AiScenariosPage";
import { AnalysisComparePage } from "./pages/AnalysisComparePage";
import { FlightDetailPage } from "./pages/FlightDetailPage";
import { LiveRacingPage } from "./pages/LiveRacingPage";
import { RealReplayPage } from "./pages/RealReplayPage";
import { HIDE_REDIS_INSPECTOR } from "./lib/featureFlags";

function Private({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <AppLayout>{children}</AppLayout>
    </RequireAuth>
  );
}

function PrivateAdmin({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <RequireAdmin>
        <AppLayout>{children}</AppLayout>
      </RequireAdmin>
    </RequireAuth>
  );
}

function Placeholder({ title }: { title: string }) {
  return (
    <Private>
      <PlaceholderPage title={title} />
    </Private>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route
        path="/performance"
        element={
          <RequireAuth>
            <PerformanceRoute />
          </RequireAuth>
        }
      />
      <Route
        path="/leaderboards"
        element={
          <Private>
            <LeaderboardsPage />
          </Private>
        }
      />
      <Route
        path="/flights"
        element={
          <Private>
            <FlightsListPage />
          </Private>
        }
      />
      <Route
        path="/flights/upload"
        element={
          <Private>
            <UploadPage />
          </Private>
        }
      />
      <Route
        path="/flights/upload/result"
        element={
          <Private>
            <UploadResultPage />
          </Private>
        }
      />
      <Route
        path="/flights/:id"
        element={
          <Private>
            <FlightDetailPage />
          </Private>
        }
      />
      <Route
        path="/flights/:id/real-replay"
        element={
          <RequireAuth>
            <RealReplayPage />
          </RequireAuth>
        }
      />
      <Route
        path="/analysis"
        element={
          <Private>
            <AnalysisComparePage />
          </Private>
        }
      />
      <Route
        path="/users"
        element={
          <Private>
            <UsersListPage />
          </Private>
        }
      />
      <Route
        path="/users/compare"
        element={
          <Private>
            <UsersComparePage />
          </Private>
        }
      />
      <Route
        path="/users/:id"
        element={
          <Private>
            <UserDetailPage />
          </Private>
        }
      />
      <Route
        path="/admins"
        element={
          <PrivateAdmin>
            <AdminsPage />
          </PrivateAdmin>
        }
      />
      {!HIDE_REDIS_INSPECTOR ? (
        <Route
          path="/admins/websocket-messages"
          element={
            <PrivateAdmin>
              <AdminRedisPage />
            </PrivateAdmin>
          }
        />
      ) : null}
      <Route
        path="/ai-coach"
        element={
          <Private>
            <AiCoachPage />
          </Private>
        }
      />
      <Route
        path="/ai-planner"
        element={
          <Private>
            <AiPlannerPage />
          </Private>
        }
      />
      <Route
        path="/ai-scenarios"
        element={
          <Private>
            <AiScenariosPage />
          </Private>
        }
      />
      <Route
        path="/live"
        element={
          <Private>
            <LiveRacingPage />
          </Private>
        }
      />

      <Route path="*" element={<Placeholder title="Not found" />} />
    </Routes>
  );
}
